<template>
  <div class="add-express-code">
    <div class="express-code-card">
      <div class="card-content">
        <div class="card-top">
          <el-input placeholder="请输入转单号(必填)" v-model="addProblemCode.order_number" style="margin-bottom:20px">
            <template slot="prepend">转单号</template>
          </el-input>
          <div class="input-select">
            <div class="el-input-group__prepend">问题类型</div>
            <div class="diy-suffix">
              <el-select id="problem_id" v-model="addProblemCode.problem_id" placeholder="请选择(必填)">
                <el-option v-for="item in problemList" :key="item.id" :label="item.problem_type" :value="item.id"></el-option>
              </el-select>
              <i class="iconfont icon-xiajiantou diy-suffix-icon" @click="handleFouceSelect('problem_id')" />
            </div>
          </div>
          <el-input v-if="userInfo.roles !== 2" placeholder="选填" v-model="addProblemCode.customer_order_number" style="margin-bottom:20px">
            <template slot="prepend">订单号</template>
          </el-input>
          <div class="input-select">
            <div class="el-input-group__prepend">发送对象</div>
            <div class="diy-suffix">
              <el-select id="send_obj" v-model="addProblemCode.send_obj" placeholder="请选择(必填)">
                <el-option v-for="item in nextFirmList" :key="item.id" :label="item.firm_name" :value="item.id"></el-option>
              </el-select>
              <i class="iconfont icon-xiajiantou diy-suffix-icon" @click="handleFouceSelect('send_obj')" />
            </div>
          </div>
          <el-input placeholder="选填" v-model="addProblemCode.channel_order_number" style="margin-bottom:20px">
            <template slot="prepend">渠道转单号</template>
          </el-input>
          <el-input placeholder="选填" v-if="userInfo.roles !== 2" v-model="addProblemCode.shop_name" style="margin-bottom:20px">
            <template slot="prepend">店铺</template>
          </el-input>
          <el-input v-if="userInfo.roles !== 2" placeholder="选填" v-model="addProblemCode.sku" style="margin-bottom:20px">
            <template slot="prepend">型号</template>
          </el-input>
        </div>
        <div class="card-bottom">
          <div class="head">
            问题描述
          </div>
          <el-input type="textarea" :rows="6" placeholder="请输入内容(必填)" v-model="addProblemCode.problem_message" resize="none">
          </el-input>
          <div class="footer">
            <div id="preview" v-on:paste="handlePaste" class="preview_img_creat">
                <span>将图片按Ctrl+V 粘贴至此处</span>
            </div>
            <!-- <el-upload class="upload-demo" action="" :http-request="uploadImg" list-type="picture-card" multiple :limit="10">
              <i class="el-icon-plus"></i>
            </el-upload> -->
          </div>
        </div>
      </div>
      <div class="card-btn">
        <el-button class="submit" type="primary" @click="submit">提交</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import { GetSellerListProblemList } from '../../api/sellerList'
import { GetNextFailyFirmList } from '../../api/nextFamily'
import { PostAddOrder } from '../../api/api'
export default {
  data: () => ({
    formData: new FormData(),
    textarea: '',
    userInfo: JSON.parse(localStorage.getItem('user_info')),
    addProblemCode: {
      order_number: '', // 转单号
      channel_order_number: '', // 渠道转单号
      problem_id: '', // 问题类型id
      send_obj: '', // 发送组织id
      problem_message: '', // 问题描述
      customer_order_number: '', // 订单号
      shop_name: '', // 商店
      sku: '' // 型号
    },
    problemList: [],
    nextFirmList: [],
    messageImgIndex: 0
  }),
  created () {
    this.init()
  },
  methods: {
    init () {
      this.$axios.all([this.getProblemList(), this.getNextFailyFirmList()]).then(this.$axios.spread((allProblem, allFirm) => {
        this.problemList = allProblem.data
        this.addProblemCode.problem_id = this.problemList[0].id
        this.nextFirmList = allFirm.data
        if (this.userInfo.roles !== 3) {
          this.addProblemCode.send_obj = 2
        }
      }))
    },
    uploadImg (data) {
      this.formData.append(`message_img[${this.messageImgIndex}]`, data.file)
      this.messageImgIndex++
    },
    submit () {
      // console.log(this.addProblemCode)
      for (const i in this.addProblemCode) {
        this.formData.append(i, this.addProblemCode[i].toString().replace(/(^\s*)|(\s*$)/g, ''))
      }
      PostAddOrder(this.formData).then(res => {
        switch (res.data) {
          case 1:
            this.$router.push('/sellerList')
            break
          case 2:
            this.$router.push('/nextFamily')
            break
          case 3:
            this.$router.push('/salesClaim')
            break
        }
      })
    },
    handleFouceSelect (val) {
      document.getElementById(val).click()
    },
    getProblemList () {
      return GetSellerListProblemList()
    },
    getNextFailyFirmList () {
      return GetNextFailyFirmList()
    },
    $ (e) {
      let eType = 'queryeAll'
      if (e.indexOf('#') === 0) {
        eType = 'getElementById'
        e = e.substr(1, e.length)
      }
      if (e.indexOf('.') === 0) {
        eType = 'getElementsByClassName'
        e = e.substr(1, e.length)
      }
      return document[eType](e)
    },
    // 监听粘贴操作
    handlePaste (event) {
      const items = (event.clipboardData || window.clipboardData).items
      let file = null

      if (!items || items.length === 0) {
        this.$message.error('当前浏览器不支持本地')
        return false
      }
      // 搜索剪切板items
      for (let i = 0; i < items.length; i++) {
        if (items[i].type.indexOf('image') !== -1) {
          file = items[i].getAsFile()
          break
        }
      }
      if (!file) {
        this.$message.error('粘贴内容非图片')
        return false
      }
      console.log(file)
      // 此时file就是我们的剪切板中的图片对象
      // 如果需要预览，可以执行下面代码
      const reader = new FileReader()
      reader.onload = event => {
        const preview = this.$('#preview')
        preview.innerHTML = `<img style="height:100px;width:200px;" src="${event.target.result}">`
        this.formData.append(`message_img[0]`, file)
      }
      reader.readAsDataURL(file)
      this.file = file
    }
  }
}
</script>

<style lang="less">
.preview_img_creat {
  width: 200px;
  height: 100px;
  border: 1px dashed #c0ccda;
  border-radius: 6px;
  background-color: #fff;
  color: #409eff;
  font-size: 12px;
  text-align: center;
  vertical-align: middle;
  line-height: 100px;
};
.el-select-dropdown__item{
  height: 22px;
  line-height: 22px;
}
.el-select-dropdown__wrap{
  max-height: 350px;
}
.express-code-card {
  max-width: 771px;
  min-height: 593px;
  padding: 32px 0;
  background: #fff;
  margin: 30px auto;
  box-shadow: 0px 2px 12px 1px rgba(34, 82, 177, 0.07);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-self: center;

  .el-input-group{
    width: 300px;
  }

  .el-textarea__inner {
    border-bottom: 2px solid #ccccd8 !important;
  }

  .card-content {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  .card-btn {
    margin: 17px auto;
    width: 100%;
    display: flex;
    justify-content: center;
  }

  .card-top {
    width: 670px;
    margin: 0 auto;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }

  .card-bottom {
    width: 670px;
    border: 2px solid #ccccd8;
    border-radius: 6px;
    margin: 0 auto;

    .head {
      width: 100%;
      height: 60px;
      border-bottom: 2px solid #ccccd8;
      font-size: 18px;
      font-weight: 400;
      color: #6e6f95;
      display: flex;
      align-items: center;
      padding-left: 13px;
    }

    .el-textarea {
      height: 136px;
      padding-bottom: 10px;
      border: none;
      textarea {
        border: none;
      }
    }

    .footer {
      width: 100%;
      // height: 164px;
      min-height: 110px;
      padding: 10px;
      border-top: 2px solid #ccccd8;

      .el-upload--picture-card {
        width: 80px;
        height: 80px;
        display: flex;
        justify-content: center;
        align-items: center;
        background: #dddfe3;
        border: none;
      }

      .el-upload-list__item {
        width: 80px;
        height: 80px;
      }
    }
  }

  .submit {
    width: 250px;
    height: 50px;
    background: #00a4a4;
    border-color: #00a4a4;
  }

  .el-input-group__prepend {
    width: 123px;
    height: 40px;
    padding: 0 20px;
    vertical-align: middle;
    background: #F0F1F4;
    font-size: 14px;
    font-weight: 400;
    color: #6E6F95;
  }

  .el-input__inner {
    width: 177px;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }

  .input-select {
    height: 40px;
    display: flex;
    line-height: normal;
    display: inline-table;
    border-collapse: separate;
    border-spacing: 0;
    font-size: 14px;
    .diy-suffix {
      position: relative;
      .diy-suffix-icon {
        position: absolute;
        right: 7px;
        top: 12px;
        cursor: pointer;
      }
      .el-input__suffix {
        display: none;
      }
      .el-input__inner {
        height: 40px;
      }
      .el-date-editor {
        width: 198px;
        margin-bottom: 5px;
        .el-input__inner {
          padding: 0 15px;
        }
        .el-input__prefix {
          display: none;
        }
      }
    }
  }
}
</style>
